import { InterceptorXHeaderIdentifierEnum } from '@interceptors/interceptors.model';

export interface IXClientAnalyticsConfig {
	readonly featureEnabled: boolean;
	readonly addComplexHeader: boolean;
	readonly addSingleHeaders: boolean;
	readonly complexHeaderName: string;
	readonly sessionStorageId: string;
}


export const X_CLIENT_ANALYTICS_CONFIG: IXClientAnalyticsConfig = {
	featureEnabled: false,
	addComplexHeader: true,
	addSingleHeaders: false,
	complexHeaderName: InterceptorXHeaderIdentifierEnum.HEADER_CLIENT_ANALYTICS,
	sessionStorageId: 'analytics'
};
